import { useEffect, useRef } from "react";
import { fileUrl } from "../../lib/api";

export function HeroSlideshow({ items = [], interval = 2600 }) {
  const trackRef = useRef(null);
  const slides = items.filter((p) => p.image);

  useEffect(() => {
    if (slides.length < 2) return;
    const id = setInterval(() => {
      const track = trackRef.current;
      const card = track && track.children[0];
      if (!track || !card) return;
      const step = card.offsetWidth + 12; // card width + mx-1.5 (6px each side)
      const maxScroll = track.scrollWidth - track.clientWidth;
      const next = track.scrollLeft + step >= maxScroll - 4 ? 0 : track.scrollLeft + step;
      track.scrollTo({ left: next, behavior: "smooth" });
    }, interval);
    return () => clearInterval(id);
  }, [slides.length, interval]);

  if (!slides.length) return null;

  return (
    <div data-testid="hero-slideshow" className="relative z-10 border-t border-ash/60 bg-obsidian/40 backdrop-blur-sm py-3">
      <div ref={trackRef} className="flex overflow-x-hidden px-1.5">
        {slides.map((p) => (
          <div key={p.id} className="w-28 h-20 sm:w-40 sm:h-28 mx-1.5 border border-ash overflow-hidden shrink-0">
            <img src={fileUrl(p.image)} alt="" className="w-full h-full object-cover grayscale" loading="eager" />
          </div>
        ))}
      </div>
    </div>
  );
}
